import React from "react";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 5,
    marginLeft: 5,
  },
  right: {
    cursor: "pointer",
    backgroundColor: "white",
    width: 40,
    height: 40,
    padding: 5,
    borderRadius: "50%",
    color: "#716162",
  },
  text: {
    color: "white",
  },
}));

const CaseButton = ({ Image, Icon, text, onClick }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {Image ? (
        <img
          className={classes.right}
          src={Image}
          onClick={onClick}
          alt="right"
        />
      ) : (
        <Icon className={classes.right} onClick={onClick} />
      )}
      <Typography className={classes.text} variant="caption">
        {text}
      </Typography>
    </div>
  );
};

export default CaseButton;
